import styled from '@emotion/styled';

export interface CardMessageProps {
  className?: string;
  title?: React.ReactNode;
  quote?: React.ReactNode;
  lazyScrollContainer?: Element | null;
}
const Wrapper = styled.div`
  padding: 8px;
  background-color: var(--fett-chat-bubble-customer);
  color: var(--fett-text-primary);
  border-radius: 4px;
  width: 420px;
  max-width: 100%;
  box-sizing: border-box;
`;
const Title = styled.div`
  font-size: 14px;
  color: var(--fett-text-secondary);
  margin-bottom: 12px;
`;

const CardMessage: React.FC<CardMessageProps> = (props) => {
  const { className, children, title, quote } = props;
  return (
    <Wrapper className={className}>
      {quote}
      {title ? <Title>{title}</Title> : null}
      <div>{children}</div>
    </Wrapper>
  );
};
export default CardMessage;
